export const GlobalCodeBox = () => import('../../components/global-code-box.vue' /* webpackChunkName: "components/global-code-box" */).then(c => wrapFunctional(c.default || c))
export const GlobalUiBox = () => import('../../components/global-ui-box.vue' /* webpackChunkName: "components/global-ui-box" */).then(c => wrapFunctional(c.default || c))
export const LazyAutoAdaptive = () => import('../../components/lazy-auto-adaptive.vue' /* webpackChunkName: "components/lazy-auto-adaptive" */).then(c => wrapFunctional(c.default || c))
export const LazyCountdown = () => import('../../components/lazy-countdown.vue' /* webpackChunkName: "components/lazy-countdown" */).then(c => wrapFunctional(c.default || c))
export const ScrollObserver = () => import('../../components/scroll-observer.vue' /* webpackChunkName: "components/scroll-observer" */).then(c => wrapFunctional(c.default || c))
export const TrackBehavior = () => import('../../components/track-behavior.vue' /* webpackChunkName: "components/track-behavior" */).then(c => wrapFunctional(c.default || c))
export const WidgetNuxtNode = () => import('../../components/widget-nuxt-node.vue' /* webpackChunkName: "components/widget-nuxt-node" */).then(c => wrapFunctional(c.default || c))
export const WidgetNuxtWrapper = () => import('../../components/widget-nuxt-wrapper.vue' /* webpackChunkName: "components/widget-nuxt-wrapper" */).then(c => wrapFunctional(c.default || c))
export const WidgetNuxt = () => import('../../components/widget-nuxt.vue' /* webpackChunkName: "components/widget-nuxt" */).then(c => wrapFunctional(c.default || c))
export const UiTapToast = () => import('../../components/ui/TapToast/TapToast.vue' /* webpackChunkName: "components/ui-tap-toast" */).then(c => wrapFunctional(c.default || c))
export const UiToastWeUIToast = () => import('../../components/ui/Toast/WeUIToast.vue' /* webpackChunkName: "components/ui-toast-we-u-i-toast" */).then(c => wrapFunctional(c.default || c))
export const UiToast = () => import('../../components/ui/Toast/index.js' /* webpackChunkName: "components/ui-toast" */).then(c => wrapFunctional(c.default || c))
export const UiToastLazyWxDownloadReminder = () => import('../../components/ui/Toast/lazy-wx-download-reminder.vue' /* webpackChunkName: "components/ui-toast-lazy-wx-download-reminder" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
